"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;
Object.defineProperty(exports, "iconElementConfig", {
  enumerable: true,
  get: function get() {
    return _configIcon.configIcon;
  }
});
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _configIcon = require("./configIcon");
var _styledIconElement = _interopRequireDefault(require("./styled-icon-element"));
var _excluded = ["icon", "color", "dataTestId", "height", "srLabel", "width", "responsiveSize"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  icon: _propTypes["default"].element.isRequired,
  color: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  height: _propTypes["default"].string,
  srLabel: _propTypes["default"].string,
  width: _propTypes["default"].string,
  responsiveSize: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.keys(_configIcon.configIcon)), _propTypes["default"].shape(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(function (acc, current) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, _propTypes["default"].oneOf(Object.keys(_configIcon.configIcon))));
  }, {}))])
};
var defaultProps = {
  color: "var(--color-global-black)",
  dataTestId: null,
  height: undefined,
  srLabel: undefined,
  width: undefined,
  responsiveSize: 'xsmall'
};
var Icon = exports.Icon = forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    color = _ref.color,
    dataTestId = _ref.dataTestId,
    height = _ref.height,
    srLabel = _ref.srLabel,
    width = _ref.width,
    responsiveSize = _ref.responsiveSize,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledIconElement["default"], _extends({
    icon: icon,
    color: color,
    "data-testid": dataTestId,
    height: height,
    ref: ref,
    width: width,
    responsiveSize: responsiveSize
  }, rest), srLabel && /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, srLabel));
});
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
var _default = exports["default"] = Icon;